import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { CONTACT_US_FROM_HEADER_PAGE_LINK, ENTERPRISE_PAGE_LINK, LOGIN_PAGE_LINK, PRICING_PAGE_LINK, ROOT_LINK } from "constants/links";
import { addProductParamToContactSalesUrl } from "segments/desktop/core-components/contact-sales-button/contact-sales-url";
import { getMiniSitePricingPageLink } from "client/services/cluster-config-service/cluster-config-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withAbTests } from "/contexts/ab-tests-context";
import PictureComponent from "components/core/picture/picture-component";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import DownloadMobileAppComponent from "./download-mobile-app/download-mobile-app-component";
import LinkComponent from "./link/link-component";
import AiSubmenuComponent from "./ai-submenu/ai-submenu-component";
import SolutionsSubmenuComponent from "./solutions-submenu/solutions-submenu-component";
import ResourcesSubmenuComponent from "./resources-submenu/resources-submenu-component";
import { StyledHeaderMenuComponent } from "./header-menu-component.scss";
import { AI_MENU_ID, SOLUTIONS_MENU_ID, RESOURCES_MENU_ID } from "segments/desktop/header/layouts/base-header/base-header-service";
import classnames from "classnames";
import ArrowRight from "static/svg/arrow-right-thin.svg";
const HeaderMenuComponent = (props)=>{
    const lastActiveSubmenuIdRef = useRef(null);
    const submenuPanelRef = useRef(null);
    const { activeSubmenuId, onSubmenuChange, isMenuOpen, isMinisitePage, isMobileOrTabletBrowser, pageClusterConfig, useProductMiniSiteConfig, abTests, translate, contactSalesProductParam } = props;
    useEffect(()=>{
        if (activeSubmenuId) {
            /**
       * Last active submenu is stored in ref for the following reasons:
       * 1. To keep the active submenu showing when closing animation is running
       * 2. To scroll to the top of the submenu when it is opened
       */ lastActiveSubmenuIdRef.current = activeSubmenuId;
            // Scroll to top of submenu when it is opened
            if (submenuPanelRef.current) {
                submenuPanelRef.current.scrollTop = 0;
            }
        }
    }, [
        activeSubmenuId
    ]);
    const SMALL_MONDAY_LOGO = "https://dapulse-res.cloudinary.com/image/upload/mobile_menu/Monday.png";
    const getPricingPageLink = ()=>{
        let minisitePricingPageLink = null;
        if (isMinisitePage) {
            minisitePricingPageLink = getMiniSitePricingPageLink(pageClusterConfig, {
                useProductMiniSiteConfig
            });
        }
        return minisitePricingPageLink || PRICING_PAGE_LINK;
    };
    const renderContactSalesMobileButton = ()=>{
        return /*#__PURE__*/ _jsx(LinkComponent, {
            className: "menu-nav-item",
            title: "header.contactSales",
            url: addProductParamToContactSalesUrl(CONTACT_US_FROM_HEADER_PAGE_LINK, contactSalesProductParam)
        });
    };
    const renderSubmenu = ()=>{
        const submenuId = activeSubmenuId || lastActiveSubmenuIdRef.current;
        if (submenuId === AI_MENU_ID) return /*#__PURE__*/ _jsx(AiSubmenuComponent, {});
        if (submenuId === SOLUTIONS_MENU_ID) return /*#__PURE__*/ _jsx(SolutionsSubmenuComponent, {});
        if (submenuId === RESOURCES_MENU_ID) return /*#__PURE__*/ _jsx(ResourcesSubmenuComponent, {});
        return null;
    };
    return /*#__PURE__*/ _jsx(StyledHeaderMenuComponent, {
        className: "header-menu-mobile-component",
        children: /*#__PURE__*/ _jsxs("div", {
            className: classnames("menu-nav-container", {
                "is-submenu-active": !!activeSubmenuId
            }),
            children: [
                /*#__PURE__*/ _jsxs("nav", {
                    className: "menu-nav menu-nav--main",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "submenu-nav-item",
                            onClick: ()=>onSubmenuChange(AI_MENU_ID),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "submenu-nav-item-title",
                                    children: translate("header.aiPlatform")
                                }),
                                /*#__PURE__*/ _jsx(ArrowRight, {
                                    className: "submenu-nav-item-arrow"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "submenu-nav-item",
                            onClick: ()=>onSubmenuChange(SOLUTIONS_MENU_ID),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "submenu-nav-item-title",
                                    children: translate("header.solutions")
                                }),
                                /*#__PURE__*/ _jsx(ArrowRight, {
                                    className: "submenu-nav-item-arrow"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "submenu-nav-item",
                            onClick: ()=>onSubmenuChange(RESOURCES_MENU_ID),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "submenu-nav-item-title",
                                    children: translate("header.resources")
                                }),
                                /*#__PURE__*/ _jsx(ArrowRight, {
                                    className: "submenu-nav-item-arrow"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(LinkComponent, {
                            className: "menu-nav-item",
                            title: "header.enterprise",
                            url: ENTERPRISE_PAGE_LINK
                        }),
                        /*#__PURE__*/ _jsx(LinkComponent, {
                            className: "menu-nav-item",
                            title: "header.pricing",
                            url: getPricingPageLink()
                        }),
                        renderContactSalesMobileButton(),
                        !isMobileOrTabletBrowser && /*#__PURE__*/ _jsx(LinkComponent, {
                            className: "menu-nav-item",
                            title: "header.logIn",
                            url: LOGIN_PAGE_LINK,
                            onClickFunc: ()=>onMainLinkClick("header.logIn")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "download-mobile-app-component-wrapper",
                            children: /*#__PURE__*/ _jsx(DownloadMobileAppComponent, {})
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "monday-link-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(PictureComponent, {
                                    src: SMALL_MONDAY_LOGO
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "monday-link-text-wrapper",
                                    children: /*#__PURE__*/ _jsx(SecondaryButton, {
                                        buttonText: translate("header.menuItem.backToHomePage"),
                                        url: ROOT_LINK,
                                        onClick: ()=>onMainLinkClick("logo")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("menu-nav menu-nav--submenu", {
                        "is-submenu-active": !!activeSubmenuId
                    }),
                    ref: submenuPanelRef,
                    children: renderSubmenu()
                })
            ]
        })
    });
};
export default withGenericConfig(withAbTests(HeaderMenuComponent));
